export { VERSION, VERSION_INFO } from './Version.generated';
export type { GeoboxGlVersionInfo } from './Version.generated';

import { VERSION, VERSION_INFO } from './Version.generated';

export function getVersion(): string {
  return VERSION;
}

export function getVersionInfo() {
  return VERSION_INFO;
}

export function compareVersions(a: string, b: string): number {
  const parse = (value: string) =>
    value
      .split('.')
      .slice(0, 3)
      .map((part) => Number.parseInt(part, 10) || 0);

  const left = parse(a);
  const right = parse(b);

  for (let i = 0; i < 3; i += 1) {
    if (left[i] > right[i]) return 1;
    if (left[i] < right[i]) return -1;
  }

  return 0;
}

export function assertMinVersion(minVersion: string, label = 'geobox-gl'): void {
  if (compareVersions(VERSION, minVersion) < 0) {
    throw new Error(
      `${label} ${VERSION} is older than required ${minVersion}. Rebuild and deploy geobox-gl.`,
    );
  }
}
